var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative",staticStyle:{"margin-left":"-16px"}},[(_vm.isEmpty)?_c('div',{staticClass:"ml-3"},[_c('b-alert',{staticClass:"mb-0",attrs:{"variant":"primary","show":""}},[_vm._v("No documents found. ")])],1):_c('canvas',{attrs:{"id":"bar"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }